var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.80972 1.09659C10.2303 0.598012 10.8913 0.598012 11.312 1.09659C11.7326 1.59516 11.7326 2.37864 11.312 2.87721L3.62043 11.9584H28.9484C29.5493 11.9584 30 12.5282 30 13.2049C30 13.9171 29.5193 14.4869 28.9484 14.4869H3.62043L11.312 23.5681C11.7326 24.0667 11.7326 24.8858 11.312 25.3487C10.8913 25.8473 10.2003 25.8473 9.80972 25.3487L0.315473 14.1308C-0.105158 13.6322 -0.105158 12.8487 0.315473 12.3502L9.80972 1.09659Z","fill":"#34495E"}));
}

LeftArrow.defaultProps = {"width":"30","height":"26","viewBox":"0 0 30 26","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
